export default [
  {
    id: "recAGJfiU4CeaV0H4",
    order: 4,
    title: "Sankalp Shandilya",
    dates: "",

    duties: [
      "React JS, React NATIVE, Node JS, Express",
      "Python, SQL, R, SCALA",
      "MySQL, MongoDB",
      "PowerBI, Tableau, MS EXCEL",
    ],
    company: "PROFILE",
  },

  {
    id: "recAGJfiU4CeaV0HL",
    order: 3,
    title: "NATIONAL INSTITUTE OF TECHNOLOGY, RAIPUR",
    dates: "July 2019 - Present",

    duties: [
      "Civil Engineering, Data Science & Machine Learning(Minor)",
      "8.91 CPI",
      "Training And Placement Coordinator",
    ],
    company: "EDUCATION",
  },

  {
    id: "recIL6mJNfWObonls",
    order: 2,
    title: "Solution Developer @ i Tech Mission",
    dates: "Sept 2021 - feb 2022",

    duties: [
      "Working on company website ( mostly back-end node.js, express.js)",
      "Developed dynamic and interactive website that ensured high traffic, page views, and user experience.",
      "Building stable and maintainable codebases using React, Nodejs, Express.js, worked on docker",
    ],
    company: "INTERNSHIP",
  },

  {
    id: "rec61x18GVY99hQq5",
    order: 1,
    title: "Hand written to doc",
    dates: "",

    duties: [
      "Creating the Validation Dataset, Creating Tensors and Setting up the Neural Network",
      "Defining the Cross Entropy Loss Function, the Optimizer and Metrics",
      "Model Architectures: Experimenting with Dropouts",
    ],
    company: "PROJECT",
  },
];
